import React from "react";
import { NumberCircle } from "./UI";

export default function AboutGuide() {
  return (
    <div className="container">
      <hr className="sz-divider mb-4" style={{ borderTopColor: "var(--sz-primary)", opacity: 0.5 }} />
      <div className="sz-intro-card">
        <h3>
          <span className="sz-intro-bar" /> About This User Guide
        </h3>
        <p className="fw-semibold">
          This User Guide is designed to help you use Selectezi efficiently
          from day one.
        </p>
        <p>Inside this guide, you'll find step by step explanations showing you how to:</p>

        <div className="row g-2">
          <div className="col-md-6">
            <NumberCircle number={1}>
              Sign up and verify your account securely and properly.
            </NumberCircle>
          </div>
          <div className="col-md-6">
            <NumberCircle number={2}>
              Use each core feature: Profile, Timeline, Messenger, Ads, and
              Business Connections.
            </NumberCircle>
          </div>
          <div className="col-md-6">
            <NumberCircle number={3}>
              Troubleshoot common issues, such as signup or login problems.
            </NumberCircle>
          </div>
          <div className="col-md-6">
            <NumberCircle number={4}>
              Contact the support team for technical or account assistance.
            </NumberCircle>
          </div>
          <div className="col-md-12">
            <NumberCircle number={5}>
              Follow the platform rules to keep the community safe and
              professional.
            </NumberCircle>
          </div>
        </div>
      </div>
    </div>
  );
}
